<div class="dialog-basic-footer">
  <ng-content></ng-content>
</div>
